module.exports = __webpack_public_path__ + "img/light-bulbs-gea92fd32d_640.65221972.jpg";